import React from 'react';
import './Spinner.css';

const Spinner = ({ size = 'medium', text = '', className = '' }) => {
  const sizeClass = `spinner-${size}`;

  return (
    <div className={`loading-spinner ${className}`}>
      <img
        src="/assets/images/loader.svg"
        alt="Loading..."
        className={`spinner-icon ${sizeClass}`}
      />
      {/* {text && <p className="spinner-text">{text}</p>} */}
    </div>
  );
};

export default Spinner;
